import { VtmnTooltip } from '@vtmn/react'
import { VpIcon } from '@vtmn-play/react'

interface CellTooltipProps {
  content: string
}
const CellTooltip: React.FunctionComponent<CellTooltipProps> = ({ content }: CellTooltipProps) => {
  return (
    <VtmnTooltip position="right" tooltip={content} className={'cell-tooltip'}>
      <VpIcon {...({ name: 'information', size: 12 } as any)} />
    </VtmnTooltip>
  )
}

export default CellTooltip

export const getTooltipCode = (accountLabelCode: string): string | null => {
  return accountLabelCode ? 'account-description.' + accountLabelCode : null
}
